export const ADMIN_REPORTING_BASE = "/admin/reporting";

/** Matches list routes with or without `/admin` router basename prefix. */
const REPORTING_LIST_PATH_PATTERN =
  /(?:^|\/)reporting\/(general|other|checkboxes)\/([^/]+)(?:\/(\d{4}-\d{2}-\d{2})\/(\d{4}-\d{2}-\d{2}))?\/?$/;

export const reportingListPath = (category: string, sectionId: string) =>
  `${ADMIN_REPORTING_BASE}/${category}/${sectionId}`;

export const reportingListPathWithDateRange = (
  category: string,
  sectionId: string,
  from: string,
  to: string,
) => `${reportingListPath(category, sectionId)}/${from}/${to}`;

export const menuSectionPath = (
  categoryUrl: string,
  subCategoryUrl: string,
  sectionId: string,
) => `/admin/${categoryUrl}/${subCategoryUrl}/${sectionId}`;

export const menuSectionPathWithDateRange = (
  categoryUrl: string,
  subCategoryUrl: string,
  sectionId: string,
  from: string,
  to: string,
) => `${menuSectionPath(categoryUrl, subCategoryUrl, sectionId)}/${from}/${to}`;

export const parseReportingListPath = (pathname: string) => {
  const match = REPORTING_LIST_PATH_PATTERN.exec(pathname);

  if (!match) {
    return undefined;
  }

  return {
    category: match[1],
    sectionId: match[2],
    from: match[3],
    to: match[4],
  };
};
